import CityPageTemplate from "../city-template/CityPageTemplate";
import { kentConfig } from "./data";

export default function KentPage() {
  return <CityPageTemplate config={kentConfig} />;
}